import React, { useState } from "react";
import {
    Box,
    Button,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { IProductExtras } from "../../../all-types";


const ProductExtrasForm: React.FC<{
    extras: IProductExtras;
    setExtras: (data: IProductExtras) => void
}> = ({extras, setExtras}) => {
    // const [extras, setExtras] = useState<IProductExtras>({});
    const [newHeading, setNewHeading] = useState("");

    const handleAddHeading = () => {
        if (!newHeading.trim() || extras[newHeading]) return;
        setExtras({
            ...extras,
            [newHeading]: [{ extraName: "", extraPrice: "" }]
        });
        setNewHeading("");
    };

    const handleExtraChange = (
        heading: string,
        index: number,
        field: "extraName" | "extraPrice",
        value: string
    ) => {
        const updated = [...extras[heading]];
        updated[index] = {
            ...updated[index],
            [field]: value
        };
        setExtras({
            ...extras,
            [heading]: updated
        });
    };

    const handleAddExtra = (heading: string) => {
        setExtras({
            ...extras,
            [heading]: [...extras[heading], { extraName: "", extraPrice: "" }]
        });
    };

    const handleRemoveExtra = (heading: string, index: number) => {
        const updated = extras[heading].filter((_, i) => i !== index);
        setExtras({
            ...extras,
            [heading]: updated.length ? updated : [{ extraName: "", extraPrice: "" }]
        });
    };

    const handleRemoveHeading = (heading: string) => {
        const updated = { ...extras };
        delete updated[heading];
        setExtras(updated);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                Product Extras
            </Typography>

            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                    label="New Heading"
                    value={newHeading}
                    onChange={(e) => setNewHeading(e.target.value)}
                />
                <Button variant="contained" onClick={handleAddHeading}>
                    Add Heading
                </Button>
            </Box>

            {Object.entries(extras).map(([heading, list]) => (
                <Box
                    key={heading}
                    sx={{ mb: 3, border: "1px solid #ccc", p: 2, borderRadius: 2 }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <Typography variant="h6" sx={{ flexGrow: 1 }}>
                            {heading}
                        </Typography>
                        <IconButton onClick={() => handleRemoveHeading(heading)}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>

                    {list.map((extra, index) => (
                        <Box
                            key={index}
                            sx={{ display: "flex", gap: 1, mb: 1, flexWrap: "wrap" }}
                        >
                            <TextField
                                label="Extra Name"
                                value={extra.extraName}
                                onChange={(e) =>
                                    handleExtraChange(heading, index, "extraName", e.target.value)
                                }
                            />
                            <TextField
                                label="Extra Price"
                                value={extra.extraPrice}
                                onChange={(e) =>
                                    handleExtraChange(heading, index, "extraPrice", e.target.value)
                                }
                            />
                            <IconButton onClick={() => handleRemoveExtra(heading, index)}>
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    ))}

                    <Button startIcon={<AddIcon />} onClick={() => handleAddExtra(heading)}>
                        Add Extra
                    </Button>
                </Box>
            ))}

            {/* <Typography variant="body1" sx={{ mt: 4 }}>
                <pre>{JSON.stringify(extras, null, 2)}</pre>
            </Typography> */}
        </Box>
    );
};

export { ProductExtrasForm };
